import styled from 'styled-components';
import { typeStyle } from '../../../styles/typeStyle';
import type { TypographyTypes } from '../Paragraph/Paragraph.data';
import type { HeadingType } from './Heading.data';

/**
 * These types are available for the heading component. Keep in mind that by default the type also
 * defines the tag that is used to render out the component. So if you choose to use the type `h2`
 * it will also render out a `<h2>` tag.
 */
export interface StyledHeadingProps extends TypographyTypes {
  $type: HeadingType;
}

export const StyledHeading = styled.h1<StyledHeadingProps>`
  ${(props) => typeStyle[props.$type]};
  margin-top: 0;
  margin-bottom: 0;
`;
